import { useEffect, useState } from "react";
import { apiFetch } from "api/Api";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Link } from "react-router-dom";

const WorkList = () => {

  const [works, setWorks] = useState([]);
  const [loading, setLoading] = useState(false);

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(5);
  const [totalPages, setTotalPages] = useState(1);

  const loadWorks = async () => {
    setLoading(true);

    try {
      const data = await apiFetch(
        `leader_admin/get_all_works?page=${page}&limit=${limit}`
      );

      setWorks(data.data || []);
      setTotalPages(data.pagination?.totalPages || 1);

    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

useEffect(() => {
  loadWorks();
}, [page, limit]);

  const getStatusBadge = (status) => {
    switch (status) {
      case "complete":
        return "badge bg-success";
      case "ongoing":
        return "badge bg-primary";
      case "pending":
        return "badge bg-warning";
      default:
        return "badge bg-secondary";
    }
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case "complete":
        return "पूर्ण";
      case "ongoing":
        return "प्रगतीमध्ये";
      case "pending":
        return "प्रलंबित";
      default:
        return status;
    }
  };
  const handleDelete = async (id) => {
    if (!window.confirm("आपण नक्कीच हा प्रकल्प हटवू इच्छिता?")) {
      return;
    }

    try {
      await apiFetch(`leader_admin/delete_work/${id}`, {
        method: "DELETE",
      });

      alert("प्रकल्प यशस्वीरित्या हटविला गेला आहे.");
      loadWorks();
    } catch (error) {
      alert(error.message);
    }
  };
    
// console.log(limit);
  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div className="container-fluid mt-4" style={{ fontSize: "0.9rem" }}>

        {/* Header */}
        <div
          className="p-4 rounded-4 shadow-lg mb-4 text-white d-flex justify-content-between align-items-center"
          style={{ background: "linear-gradient(135deg,#002B5B,#007BFF)" }}
        >
          <div>
            <h4 className="fw-bold mb-1" style={{ fontSize: "1.2rem" }}>📋 प्रकल्प व्यवस्थापन</h4>
            <small style={{ fontSize: "0.85rem" }}>प्रकल्पांची यादी पहा आणि संपादित करा</small>
          </div>

          <Link to="/add_work" className="btn btn-light fw-semibold" style={{ fontSize: "0.8rem" }}>
            + नवीन प्रकल्प
          </Link>
        </div>
<div className="d-flex justify-content-between align-items-center mb-3">

  <div>
    <label className="me-2 fw-semibold" style={{ fontSize: "0.85rem" }}>रेकॉर्ड दाखवा</label>

    <select
      className="form-select d-inline-block"
      style={{ width: "100px" }}
      value={limit}
      onChange={(e) => {
        setPage(1);
        setLimit(Number(e.target.value));
      }}
    >
      <option value={5}>5</option>
      <option value={10}>10</option>
      <option value={20}>20</option>
      <option value={50}>50</option>
    </select>

  </div>

</div>
        {/* Table */}
        <div className="card shadow-lg border-0 rounded-4">
          <div className="card-body">

            {loading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-primary"></div>
              </div>
            ) : (
              <>
                <div className="table-responsive">
                  <table className="table table-hover align-middle" style={{ fontSize: "0.85rem" }}>

                    <thead
                      className="text-white"
                      style={{ backgroundColor: "#002B5B" }}
                    >
                      <tr>
                        <th>Sr. No.</th>
                        <th>प्रकल्प</th>
                        <th>सुरू दिनांक</th>
                        <th>समाप्त दिनांक</th>
                        <th>अंदाजे खर्च</th>
                        <th>स्थिती</th>
                        <th>सोपविले</th>
                        <th>मोबाईल</th>
                        <th className="text-center">क्रिया</th>
                      </tr>
                    </thead>

                    <tbody>
                      {works.length === 0 ? (
                        <tr>
                          <td colSpan="9" className="text-center py-4">
                            कोणतेही प्रकल्प उपलब्ध नाहीत
                          </td>
                        </tr>
                      ) : (
                        works.map((item, index) => (
                          <tr key={item.project_id}>

                            <td>{(page - 1) * limit + index + 1}</td>

                            <td className="fw-semibold">
                              {item.project_title}
                              <br />
                              <small className="text-muted">
                                {item.description?.substring(0, 40)}
                              </small>
                            </td>

                            <td>
                              {new Date(item.start_date).toLocaleDateString("mr-IN")}
                            </td>

                            <td>
                              {item.end_date
                                ? new Date(item.end_date).toLocaleDateString("mr-IN")
                                : "-"}
                            </td>

                            <td>
                              ₹ {item.estimate_cost}
                            </td>

                            <td>
                              <span className={getStatusBadge(item.status)}>
                                {getStatusLabel(item.status)}
                              </span>
                            </td>

                            <td>{item.assign_to}</td>

                            <td>{item.mobile_no}</td>

                            <td className="text-center">

                              <Link
                                to={`/edit_work/${item.project_id}`}
                                className="btn btn-sm btn-outline-primary me-2"
                              >
                                संपादन
                              </Link>
                             
                              <button
                                onClick={() => handleDelete(item.project_id)}
                                className="btn btn-sm btn-outline-danger"
                              >
                                हटवा
                              </button>

                            </td>

                          </tr>
                        ))
                      )}
                    </tbody>

                  </table>
                </div>

                {/* Pagination */}
                <div className="d-flex justify-content-between align-items-center mt-4">

                  <small className="text-muted">
                    पृष्ठ {page} पैकी {totalPages}
                  </small>

                  <nav>
                    <ul className="pagination mb-0">

                      <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                        <button
                          className="page-link"
                          onClick={() => setPage(page - 1)}
                        >
                          मागील
                        </button>
                      </li>

                      {[...Array(totalPages)].map((_, i) => (
                        <li
                          key={i}
                          className={`page-item ${page === i + 1 ? "active" : ""}`}
                        >
                          <button
                            className="page-link"
                            onClick={() => setPage(i + 1)}
                          >
                            {i + 1}
                          </button>
                        </li>
                      ))}

                      <li
                        className={`page-item ${
                          page === totalPages ? "disabled" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => setPage(page + 1)}
                        >
                          पुढील
                        </button>
                      </li>

                    </ul>
                  </nav>

                </div>

              </>
            )}

          </div>
        </div>

      </div>
    </DashboardLayout>
  );
};

export default WorkList;